import React, {ChangeEventHandler, useCallback, useEffect, useId, useRef, useState} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import cs from 'classnames';
import {Loader} from 'components/Loader';

interface IQuantityInputProps {
    handleChange?: (quantity: number) => void;
    value: number;
    isLoading: boolean;
}

export const Quantity = (props: IQuantityInputProps) => {
    const {handleChange, value, isLoading} = props;
    const [isFocused, setIsFocused] = React.useState(false);
    const ref = useRef<HTMLLabelElement>(null);
    const [isBlankField, setIsBlankField] = useState(false);
    const inputId = useId();

    const onChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
        (e) => {
            if ('' === e.target.value) {
                setIsBlankField(true);
                return;
            }
            setIsBlankField(false);

            const inputValue = Number(e.target.value);
            if (Number.isNaN(inputValue) || !Number.isInteger(inputValue)) {
                return;
            }

            handleChange?.(inputValue);
        },
        [handleChange],
    );

    useEffect(() => {
        const inputRef = ref.current;

        const onFocus = () => {
            setIsFocused(true);
        };

        const onUnFocus = () => {
            setIsFocused(false);
        };

        if (inputRef) {
            inputRef.addEventListener('focusout', onUnFocus);
            inputRef.addEventListener('focusin', onFocus);
        }

        return () => {
            if (inputRef) {
                inputRef.removeEventListener('focusout', onUnFocus);
                inputRef.removeEventListener('focusin', onFocus);
            }
        };
    }, []);

    return (
        <label htmlFor={inputId} className={cs(style.label)} ref={ref}>
            <Typography
                variants={{DT: 'body-16-r', TB: 'body-16-r', MB: 'body-16-r'}}
                element={'div'}
                className={style.counter}
            >
                {isLoading ? (
                    <Loader size={'md'} color={'white'} />
                ) : (
                    <input
                        id={inputId}
                        autoComplete={'off'}
                        autoCorrect={'off'}
                        autoCapitalize={'off'}
                        spellCheck={'false'}
                        className={cs(style.input, {[style.input_focused]: isFocused})}
                        value={isBlankField ? '' : value}
                        type={'text'}
                        onChange={onChange}
                    />
                )}
            </Typography>
        </label>
    );
};
